import axios from "axios";
import store from "@/store/index";
import * as types from "@/store/types";
import router from "@/router/index";
import jwtManager from '@/store/jwtManager'

class BaseService {
  constructor() {
    let token = jwtManager.getJwt();
    let service = axios.create({
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    service.interceptors.request.use(
      this.handleSuccessRequest,
      this.handleErrorRequest
    );
    service.interceptors.response.use(
      this.handleSuccessResponse,
      this.handleErrorResponse
    );
    this.service = service;

    if (
      location.hostname === "localhost" ||
      location.hostname === "127.0.0.1"
    ) {
      this.baseUrl = "https://localhost:5001";
    } else {
      this.baseUrl = "https://vduris.eu/api";
    }
  }

  handleSuccessRequest(config) {
    return config;
  }

  handleSuccessResponse(response) {
    return response;
  }

  handleErrorRequest = error => {
    return Promise.reject(error);
  };

  handleErrorResponse = error => {
    if (error.response === undefined) {
      this.showAlert(error);
      return Promise.reject(error);
    }

    switch (error.response.status) {
      case 401:
        this.logout();

        router.push({
          path: "/auth",
          query: {
            redirect: router.currentRoute.fullPath
          }
        });

        this.showAlert("Vaše prihlásenie expirovalo.");

        break;
      case 404:
        this.showAlert("error");
        console.error("404");
        console.error(error.response);
        break;
      default:
        this.showAlert("error");
        console.error("default");
        console.error(error.response);
        break;
    }
    return Promise.reject(error);
  };

  showAlert(code) {
    store.commit(types.SHOW_GLOBAL_ALERT, {
      value: true,
      message: code,
      color: "error",
    });
  }

  logout() {
    store.commit('logout')
  }

  redirectTo = (document, path) => {
    document.location = path;
  };
}

export default BaseService;